import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, CheckCircle, Pencil, ClipboardList } from "lucide-react";
import api, { apiErrorMsg } from "@/lib/api";
import { toast } from "sonner";

export default function SiswaPeriode() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/siswa/periode").then((r) => setList(r.data)).catch((e) => toast.error(apiErrorMsg(e))).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 md:p-12">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-brass-600 font-semibold mb-1">Persoalan Anda</div>
        <h1 className="font-heading text-3xl font-bold text-navy-900">Jadwal Penilaian Aktif</h1>
        <p className="text-slate-500 mt-1 text-sm">Pilih periode untuk mengisi Sosiometri. Anda akan menilai 3 rekan dengan sistem rotating.</p>
      </div>

      {loading ? <div className="text-slate-500">Memuat...</div> : list.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-sm p-12 text-center">
          <Calendar className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <div className="text-slate-500">Belum ada jadwal penilaian aktif untuk Anda.</div>
        </div>
      ) : (
        <div className="space-y-3" data-testid="siswa-periode-list">
          {list.map((p) => (
            <div key={p.id} className={`border rounded-sm p-5 transition-all ${p.sudah_mengisi ? "bg-emerald-50 border-emerald-200" : "bg-white border-slate-200 hover:border-brass-400"}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <Calendar className="w-4 h-4 text-brass-500" />
                    <span className="font-heading font-bold text-lg text-navy-900">Penilaian {p.jenis === "mingguan" ? "Mingguan" : "Bulanan"} ke-{p.nomor}</span>
                  </div>
                  <div className="text-sm text-slate-500">{p.bulan} {p.tahun}</div>
                  {p.sudah_mengisi && (
                    <div className="mt-2 inline-flex items-center gap-1.5 px-2 py-1 bg-emerald-100 text-emerald-800 rounded-sm text-xs font-semibold">
                      <CheckCircle className="w-3.5 h-3.5" /> Sudah mengisi pada {new Date(p.submitted_at).toLocaleString("id-ID")}
                    </div>
                  )}
                </div>
                <Link to={`/siswa/periode/${p.id}`} className={`px-5 py-2.5 rounded-sm font-semibold text-sm flex items-center gap-2 ${p.sudah_mengisi ? "bg-white border border-emerald-300 text-emerald-700 hover:bg-emerald-50" : "bg-brass-500 hover:bg-brass-600 text-white"}`}>
                  {p.sudah_mengisi ? <><Pencil className="w-4 h-4" /> Lihat / Edit</> : <><ClipboardList className="w-4 h-4" /> Mulai Isi</>}
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
